import React, { Component } from 'react'

// Components
import TabSelect from '../Global/TabSelect'

class UserPortalNavBar extends Component {

  state = {
    tabs: [],
    currentTab: '',
    windowWidth: 0,
    windowHeight: 0,
    breakpoint: 880
  }

  componentDidMount() {
    const { tabs } = this.props
    this.setState({tabs})
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tabs) {
      this.setState({
        tabs: nextProps.tabs
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState(state => ({
      ...state,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }))
  }

  getResponsiveStatusClass() {
    const { windowWidth, breakpoint } = this.state

    if (windowWidth <= breakpoint) {
      return ' big-phone'
    } else {
      return ''
    }
  }

  render() {
    const { className, currentTab } = this.props
    const { tabs, breakpoint } = this.state

    return (
      <nav className={`user-portal-nav-bar${this.getResponsiveStatusClass()}${className ? ' ' + className : ''}`}>
        <TabSelect
          breakpoint={breakpoint}
          tabs={tabs}
          currentTabSlug={currentTab}
        />
      </nav>
    )
  }
}

export default UserPortalNavBar



// WEBPACK FOOTER //
// ./src/components/UserPortal/UserPortalNavBar.js